import React from 'react';
import Card2 from './Card2';

const Services = ({ type, title, subtitle }) => {
  const cardsDetails = [
    {
      id: 1,
      type: 'steps',
      title: 'Crea tu cuenta',
      description: 'Registrate en pocos pasos en el sitio web o desde la app.',
      image: '../img/1.png',
    },
    {
      id: 2,
      type: 'steps',
      title: 'Depositá',
      description:
        'Realizá tu depósito inicial mediante transferencia o Mercado Pago.',
      image: 'img/2.png',
    },
    {
      id: 3,
      type: 'steps',
      title: 'Guardá, comprá y vendé',
      description:
        'Tu dinero en pesos, bitcoin y otras cripto. Usalo como quieras.',
      image: 'img/3.png',
    },
    {
      id: 4,
      type: 'services',
      title: 'Depositá pesos',
      description:
        'Fondeá tu cuenta por transferencia bancaria, Mercado Pago o efectivo.',
      image: 'img/billetera.png',
    },
    {
      id: 5,
      type: 'services',
      title: 'Comprá cripto',
      description:
        'Accedé a bitcoins y otros activos digitales en pocos pasos.',
      image: 'img/bolsa.png',
    },
    {
      id: 6,
      type: 'services',
      title: 'Gestioná tus fondos',
      description:
        'Guardá y enviá tus cripto o retirá tus fondos cuando quieras.',
      image: 'img/ahorro.png',
    },
  ];

  return (
    <div>
      <section id='pasos'>
        <div className='container pt-5 pb-5'>
          <div className='row justify-content-center text-center mt-5 mb-5'>
            <div className='col-md-10 texto-servicios'>
              <h2>{title}</h2>
              <p>{subtitle}</p>
            </div>
          </div>
          <div className='row justify-content-center mt-5 mb-5'>
            {cardsDetails.map((card) =>
              card.type === type ? (
                <div className='col-md-4'>
                  <Card2 key={card.id} details={card} />
                </div>
              ) : null
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
